import { useAppState } from '../state/appstate/appstate';

export const getConfigurationUrl = (): string => {
  const {
    configurationId,
    styleProduct: {
      style: { id: styleId } = { id: undefined },
      product: { id: productId } = { id: undefined },
    },
    uState: { currency } = { currency: undefined },
  } = useAppState.getState();

  return `${window.location.origin}/?${configurationId ? `c=${configurationId}&` : ''}${
    productId ? `p=${productId}&` : ''
  }${styleId ? `s=${styleId}&` : ''}${currency ? `m=${currency}` : ''}`;
};
